/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseStructuresStructureIdNotFound
 */
export interface GetUniverseStructuresStructureIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseStructuresStructureIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseStructuresStructureIdNotFound interface.
 */
export function instanceOfGetUniverseStructuresStructureIdNotFound(value: object): value is GetUniverseStructuresStructureIdNotFound {
    return true;
}

export function GetUniverseStructuresStructureIdNotFoundFromJSON(json: any): GetUniverseStructuresStructureIdNotFound {
    return GetUniverseStructuresStructureIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStructuresStructureIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseStructuresStructureIdNotFoundToJSON(json: any): GetUniverseStructuresStructureIdNotFound {
    return GetUniverseStructuresStructureIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseStructuresStructureIdNotFoundToJSONTyped(value?: GetUniverseStructuresStructureIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

